"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_1 = require("@angular/platform-browser");
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var navigation_service_1 = require("./api/navigation.service");
var nav_bar_type_1 = require("./nav-bar/nav-bar-type");
var navigation_message_service_1 = require("../../services/navigation-message-service");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
/**
 * Handles the titles depending on navigation bar
 * */
var NavigationItemTitleHandlerService = /** @class */ (function () {
    function NavigationItemTitleHandlerService(titleService, router, navigationService, messageService, currentLanguageProvider, authenticationService) {
        this.titleService = titleService;
        this.router = router;
        this.navigationService = navigationService;
        this.messageService = messageService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.authenticationService = authenticationService;
        this._defaultTitle = this.titleService.getTitle();
        this._routes = new Map();
    }
    /**
     * Subscribes to changes of router, and current language
     * */
    NavigationItemTitleHandlerService.prototype.subscribeToNavigationChanges = function () {
        var _this = this;
        return this.router.events.pipe(operators_1.filter(function (event) { return event instanceof router_1.NavigationEnd; }), operators_1.switchMap(function () { return _this.getCurrentRouteTitle(); }));
    };
    NavigationItemTitleHandlerService.prototype.getCurrentRouteTitle = function () {
        var _this = this;
        return this.authenticationService.isLoggedOn().pipe(operators_1.switchMap(function (isLogged) {
            var title$ = Observable_1.Observable.of('');
            if (isLogged) {
                _this._routes.forEach(function (value, key) {
                    if (_this.router.url.startsWith(key)) {
                        title$ = _this.getRouteTitle(value, key);
                    }
                });
            }
            else {
                title$ = Observable_1.Observable.of(_this._defaultTitle);
            }
            return title$;
        }), operators_1.filter(function (title) { return !!title; }));
    };
    NavigationItemTitleHandlerService.prototype.getRouteTitle = function (value, key) {
        var _this = this;
        return this.messageService.getMessage(value).pipe(operators_1.filter(function () { return _this.router.url.startsWith(key); }), operators_1.distinctUntilChanged());
    };
    /**
     * Initializes the routes map depending on navigation items
     * */
    NavigationItemTitleHandlerService.prototype.initRoutes = function (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.navBarType !== nav_bar_type_1.NavBarType.ITEM) {
                var result = this.initRoutes(item.children);
                if (result) {
                    return result;
                }
            }
            else {
                this._routes.set(item.routeLink, item.titleKey);
            }
        }
    };
    NavigationItemTitleHandlerService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [platform_browser_1.Title,
            router_1.Router,
            navigation_service_1.NavigationService,
            navigation_message_service_1.NavigationMessageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_authentication_client_js_1.AuthenticationService])
    ], NavigationItemTitleHandlerService);
    return NavigationItemTitleHandlerService;
}());
exports.NavigationItemTitleHandlerService = NavigationItemTitleHandlerService;
//# sourceMappingURL=navigation-item-title-handler.service.js.map